<div class="flex flex-col h-full">
  <!-- Manufacturer Selector -->
  <div class="p-2 border-b">
    <p-dropdown
      [options]="manufacturers"
      [(ngModel)]="selectedManufacturer"
      optionLabel="name"
      placeholder="Select Manufacturer"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      (onChange)="onManufacturerChange()"
      styleClass="w-full"
    ></p-dropdown>
  </div>

  <!-- Chart Area -->
  <div class="flex-1 min-h-0">
    <ag-charts
      *ngIf="options"
      [options]="options"
      style="width: 100%; height: 100%; display: block"
    ></ag-charts>
    <div *ngIf="!options && !selectedManufacturer" class="flex items-center justify-center h-full text-gray-500">
      Select a manufacturer to view inventory
    </div>
    <div *ngIf="!options && selectedManufacturer" class="flex items-center justify-center h-full text-gray-500">
      No inventory data for {{ selectedManufacturer.name }}
    </div>
  </div>
</div>
